import { Route } from '../models/route';
import { Profile } from '../models/profile';
import { Travel } from '../models/travel';
import { ROUTE_TYPE } from '../constants';

export const getCommittente = (travel: Travel): Profile => {
  const { actor = {} as Profile, route = {} as Route } = travel || {};
  const { owner = {} as Profile, type = '' } = route || {};

  if (type === ROUTE_TYPE.send) {
    return owner;
  } else {
    return actor;
  }
};

export const amICarrier = (travel: Travel, profile: Profile) => {
  const { actor = {} as Profile, route = {} as Route } = travel || {};
  const { owner = {} as Profile, type = '' } = route || {};
  const { id = '' } = profile || {};

  if (type === ROUTE_TYPE.send) {
    if (id === actor.id) {
      return true;
    }
  } else if (type === ROUTE_TYPE.carry) {
    if (id === owner.id) {
      return true;
    }
  }

  return false;
};
